export const DELIVERINFO_FILE = 'DELIVERINFO_FILE';
// 更新
export const DELIVERINFO_UPDATE = 'DELIVERINFO_UPDATE';
